<template>
  <div>
    <v-list>
      <ListItem
        :title="propagandist.id"
        :subtitle="$t('fields.id')"
      />
      <ListItem
        :title="propagandist.name"
        :subtitle="$t('fields.name')"
      />
      <ListItem
        :title="propagandist.surname"
        :subtitle="$t('fields.surname')"
      />
      <ListItem
        :title="propagandist.phone"
        :subtitle="$t('fields.phone')"
      />
      <ListItem
        :title="propagandist.email"
        :subtitle="$t('fields.email')"
      />
    </v-list>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';

  import ListItem from '../../shared/Lists/ListItem';

  export default {
    name: 'PropagandistDetails',
    components: { ListItem },
    props: {
      propagandist: {
        type: Object,
        default: () => {},
      },
    },
    methods: {
      ...mapActions('confirm', ['showConfirm']),
      ...mapActions('alert', ['showToast']),
    },
  };
</script>
